import ActionTemplate from '../action/templates/action.twig';
import Observer from '../../common/scripts/observer';
import ProgressTemplate from '../progress/templates/items.twig';
import Utils from '../../common/scripts/utils';

const observer = new Observer();
const lastArrayIndex = -1;

class ShowMore {
    constructor(options) {
        this.template = '';
        this.loadMore = options.button;
        this.list = options.listWrapper;
        this.itemClass = options.itemClass;
        this.nodesAfterLastItem = options.nodesAfterLastItem;
        this.baseText = this.loadMore.textContent;
        this.loadingText = options.loadingText || `Загрузка`;
        this.url = options.url;
    }

    /**
     * Инициализация экземпляра класса
     * @public
     */
    init() {
        this._bindEvents();
    }

    /**
     * Бинд событий
     * @private
     */
    _bindEvents() {
        this.loadMore.addEventListener('click', () => {
            const data = {
                count: this.list.childElementCount - this.nodesAfterLastItem
            };

            if (this.list.dataset.content) {
                data['loadMore'] = this.list.dataset.content;
            }

            this._loadReports(data);
        });
    }

    /**
     * Подгружает новые альбомы хода строительства
     * @param {object} sendData - отправляемые данные
     * @private
     */
    _loadReports(sendData = {}) {
        const formData = this._convertObjectToFormData(sendData);
        const that = this;

        that._disableMore();
        that._addLoadingState();

        this._checkTemplate();

        Utils.send(formData, that.url, {
            success(response) {
                const {data} = response;

                that._checkLastPage(data.more);
                that._insertItems(data);

                if (that.url.match('progress')) {
                    observer.publish('loadProgress', that.list, data.reports.length);
                } else if (that.url.match('news') || that.url.match('all') || that.url.match('actions')) {
                    observer.publish('loadProgress', that.list, data.offers.length);
                }

                observer.publish('popup:refresh');
            },
            error(error) {
                console.error(error);
            },
            complete() {
                that._enableMore();
                that._removeLoadingState();
            }
        });
    }

    /**
     * Конвертирует объект в экземпляр класса FormData
     * @param {object} data - данные для конвертации
     * @return {object} - объект FormData
     * @private
     */
    _convertObjectToFormData(data) {
        const formData = new FormData();

        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });

        return formData;
    }

    _checkTemplate() {
        const that = this;

        if (that.url.match('progress')) {
            this.template = ProgressTemplate;
        } else if (that.url.match('news') || that.url.match('all') || that.url.match('actions')) {
            this.template = ActionTemplate;
        }
    }

    /**
     * Вставляет новые элементы в контейнер
     * @param {object} data - данные для заполнения шаблона
     * @private
     */
    _insertItems(data) {
        this._checkTemplate(data);
        const lastItem = [].slice.call(this.list.querySelectorAll(this.itemClass)).splice(lastArrayIndex)[0];

        lastItem.insertAdjacentHTML('afterend', this.template(data));
    }

    /**
     * Если полседняя стр. то убирает кнопку load more
     * @param {boolean} state - последняя ли стр.
     * @private
     */
    _checkLastPage(state) {
        this.loadMore.style.display = state ? 'block' : 'none';
    }

    /**
     * Деакцтивирует кнопку подгрузки
     * @private
     */
    _disableMore() {
        this.loadMore.classList.add('is-disabled');
    }

    /**
     * Активирует кнопку подгрузки
     * @private
     */
    _enableMore() {
        this.loadMore.classList.remove('is-disabled');
    }

    /**
     * Добавляет класс анимации загрузки
     * @private
     */
    _addLoadingState() {
        this.loadMore.classList.add('is-loading');
        this.loadMore.textContent = this.loadingText;
    }

    /**
     * Удаляет класс анимации загрузки
     * @private
     */
    _removeLoadingState() {
        this.loadMore.classList.remove('is-loading');
        this.loadMore.textContent = this.baseText;
    }
}

export default ShowMore;

